"use client";

import React, { useContext } from "react";
import { GlobalContext } from "@/contexts/SiteDataContext";
import "./styles.scss";
import { Title } from "@/components/atoms/Title/title";

const ContactInfo = ({
  contactPhoneNumber,
  contactHours,
}: {
  contactPhoneNumber: string;
  contactHours: string;
}) => {
  const { t } = useContext(GlobalContext).context;

  const data = {
    title: t["Contact Us"],
    subtitle: `${t["If you’re having difficulties using our website or have any questions about our service, we’re on hand to help."]}`,
    phone: contactPhoneNumber,
    hours: t[contactHours],
  };

  return (
    <div className="ContactInfo">
      <div className="ContactInfo__left">
        <div>
          <Title
            hero
            tag="h1"
            content={data.title}
          />
          <p className="ContactInfo__subtitle">{data.subtitle}</p>
        </div>
      </div>
      <div className="ContactInfo__right">
        <div className="ContactInfo__phoneTitle">{t["Contact Phone"]}</div>
        <div className="ContactInfo__phone">
          <a href={`tel:${data.phone}`}>{data.phone}</a>
        </div>
        <p className="ContactInfo__hours">{data.hours}</p>
      </div>
    </div>
  );
};

export default ContactInfo;
